// extracted by mini-css-extract-plugin
module.exports = {"root":"_28r-1","itemClickWrapper":"_1E-FJ","imageZoomBtn":"_3WVKv","sizer":"_1pZJd","imageWrapper":"_3HZCq","imageBorder":"DMiEl","image":"_3lG4F","overlay":"Yapir"};